import * as React from 'react';
import ProductCompareRepository from "../../repository/ProductCompareRepository";
import { Tooltip } from "../../component/Global/Tooltip";

const ProductCompareSelection = (props) => {
  const { single_product, model_ProductCompare_data } = props;
  const status = !!(single_product && model_ProductCompare_data && model_ProductCompare_data[single_product.ItemNumber] && model_ProductCompare_data[single_product.ItemNumber]);

  const inputRender = (isOnChange = true) => {
    const checkbox = isOnChange ?
      <input type="checkbox"
        onChange={() => { validateCompareSelection() }}
        checked={status}
        className="form-check-input"
        id={'compare' + single_product.ItemNumber}
      />
      :
      <input type="checkbox" checked={status} className="form-check-input" />
    return checkbox
  };

  const validateCompareSelection = async () => {
    await new ProductCompareRepository().toggleSingleProduct(single_product);
    await new ProductCompareRepository().fetchAllData();
    return true;
  }

  return (
    <>
      {single_product &&
        <section
          className="form-check sm-custom_checkbox">
          {status === false && Object.entries(model_ProductCompare_data).length > 9 ?
            <Tooltip position={'right center'}
              opener={() => (inputRender(false))}
              content={() => (
                <div>
                  Part cannot be added. Product compare is limited to 10 parts.
                </div>
              )}
            /> :
            inputRender()
          }
          <label className="form-check-label" htmlFor={'compare' + single_product.ItemNumber}>Compare</label>
        </section>
      }
    </>
  );
}

export default ProductCompareSelection;